import { Component } from '@angular/core';
import { DialogRef } from 'src/modules/base/components/dialog/dialog-ref';
import { DialogConfig } from 'src/modules/base/components/dialog/dialog-config';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { ModalSize, SmartModalService } from "src/modules/base/services/smart-modal.service";

interface CashRow {
  value: number;
  qty: number;
}
@Component({
  selector: 'app-cash-denomination',
  standalone: false,
  templateUrl: './cash-denomination.component.html',
  styleUrl: './cash-denomination.component.scss'
})
export class CashDenominationComponent {
   rows: CashRow[] = [
    { value: 2000, qty: 1 },
    { value: 20, qty: 2 }
  ];
  updateForm:boolean = false;
  cash_den_data:any;
  totalQty: number = 0;
netCash: number = 0;
op_popup_data:any;
savedCashData:any;
    constructor(
    private dialog: DialogRef,
    private dialogConfig: DialogConfig,
        public baseService: BaseService,
            private smartModalService: SmartModalService
  ) {}
  ngOnInit() {
    debugger;
       let savedData = JSON.parse(
        sessionStorage.getItem('cash_DenData') || '{}'
    );
        this.op_popup_data = this.dialogConfig;
          var params = {
                  filter: "status:Active,currency_code:" + JSON.parse(localStorage.getItem('CURRENT_ORGANIZATION')).currency
                  }
                this.baseService.getData(params, "", "facility_master_cash_denomination", "facility-management", 'GET_PAGE').subscribe(
                                    result => {
        if (result?.errCode == 0 && result?.resource && result?.resource?.length > 0) {
          this.cash_den_data = result.resource;
          if(savedData && savedData[this.op_popup_data?.index])
          this.restoreCashData(this.cash_den_data,savedData)
        else
          this.updateForm = true;
        }
    })
  }

increaseQty(row: any) {

    row.qty = +(row.qty || 0);

    row.qty++;
      this.recalculate();

}
onQtyChange(row: any, value: any) {

    row.qty = +value || 0;
        this.recalculate();

}
decreaseQty(row: any) {

    row.qty = +(row.qty || 0);

    if (row.qty > 0) {
        row.qty--;
    }
      this.recalculate();

}

  getAmount(row: CashRow): number {
    return row['cash_denomination'] * row.qty;
  }

// totalQty(): number {

//     return this.rows.reduce((sum, row) => {

//         return sum + (+row.qty || 0);

//     }, 0);
// }

get totalAmount(): number {

    // return this.rows.reduce((sum, row) => {

    //     return sum + (
    //         (+row['cash_denomination'] || 0) *
    //         (+row.qty || 0)
    //     );

    // }, 0);
    if(this.op_popup_data.da?.[this.op_popup_data?.index]?.received_amount)
    return this.op_popup_data.da?.[this.op_popup_data?.index]?.received_amount;
  else if(this.op_popup_data.da?.amount)
    return this.op_popup_data.da?.amount;
}
recalculate() {
  this.totalQty = this.cash_den_data.reduce((sum, r) => sum + (Number(r.qty) || 0), 0);

  this.netCash = this.cash_den_data.reduce((sum, r) => {
    return sum + (Number(r.qty) || 0) * (Number(r.cash_denomination) || 0);
  }, 0);
}
get balance(): number {

    return this.totalAmount - (+this.netCash || 0);
}
  submit() {
    console.log('Submitted Data:', this.rows);
  }
  closepopup()
  {
  this.dialog.close();
  }
  restoreCashData(apiResponse: any[],savedData) {
    const savedRows = savedData[this.op_popup_data.index].rows || [];

    this.cash_den_data = apiResponse.map((item: any) => {

        const matchedRow = savedRows.find(
            (x: any) => +x.value === +item.cash_denomination
        );

        return {

            ...item,

            qty: matchedRow
                ? (+matchedRow.qty || 0)
                : 0
        };
    });

    this.netCash = +savedData[this.op_popup_data.index].netCash || 0;
    this.updateForm = true;
}
    onSubmit(e)
  {
        const payload = {    
        rows: this.cash_den_data.map((row: any) => ({

            value: +row.cash_denomination || 0,

            qty: +row.qty || 0,

            amount:
                (+row.cash_denomination || 0) *
                (+row.qty || 0)

        })),
                totalQty: this.totalQty,

        totalAmount: this.totalAmount,

        netCash: this.netCash,

        balance: this.balance,
        index:this.op_popup_data.index
    };
      //let data={"payer":this.bill_payer, "treat":this.bill_treating, "treatingDoctorLength": this.op_popup_data.da.length}
      this.smartModalService.sendResult(payload);
          this.dialog.close();

  }

}
